import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgotPasswordService from "../../services/admin/ForgotPasswordService";
import ToastHelper from "../../utils/ToastHelper";
import * as Yup from "yup";
import * as ValidationRule from "../../utils/ValidationRule";
import ValidationHelper from "../../utils/ValidationHelper";
import SFXButtonComponent from "../../components/SFXButtonComponent";

const FORGOT_PASSWORD_CONFIG = [
  {
    dataField: "username", dataLabel: "Username", type: "text",
    yup: Yup.string()
      .required('Username is required')
  },
  {
    dataField: "cellphoneNumber", dataLabel: "Cellphone Number",
    yup: ValidationRule.getCellphoneNumberRule("Cellphone Number", true)
  }
];

class ForgotPasswordComponent extends Component {

  constructor(props) {
    super(props);

    this.validationSchema = ValidationHelper.buildValidationSchema(FORGOT_PASSWORD_CONFIG);

    this.state = {
      username: '',
      errors: {},
      cellphoneNumber: '',
      mobile: this.isMobile(), // on mobile we swap the SFX logo above the Login components
      passwordChangeSuccessfulPopUp: false,
      firstLoad: true
    };

    this.handleResize = this.handleResize.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  validateForm() {
    return this.state.errors["username"] === undefined && this.state.errors["cellphoneNumber"] === undefined && this.state.firstLoad === false;
  }

  handleChange = event => {

    let value = event.target.value;

    let jsonObj = {};
    jsonObj["username"] = this.state.username;
    jsonObj["cellphoneNumber"] = this.state.cellphoneNumber;
    jsonObj[event.target.id] = value;

    let errors = ValidationHelper.validate(this.validationSchema, jsonObj);

    this.setState({
      firstLoad: false,
      [event.target.id]: event.target.value,
      errors: errors
    });
  };

  handleSubmit = function (event) {
    event.preventDefault();
    this.setState({isLoading: true});
    let self = this;

    ForgotPasswordService.forgotPassword(this.state.username, this.state.cellphoneNumber).then(response => {
      if (response === "success") {
        self.toggleForgotPassword();
      }
      else {
        ToastHelper.error("Invalid Input")
      }
    })
  };

  isMobile() {
    return window.innerWidth < 575;
  }

  handleResize() {
    if (window) {
      this.setState({mobile: this.isMobile()});
    }
  }

  componentWillMount() {
    if (window) window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    if (window) window.removeEventListener('resize', this.handleResize);
  }

  toggleForgotPassword() {
    this.setState({
      passwordChangeSuccessfulPopUp: !this.state.passwordChangeSuccessPopUp
    })
  }


  render() {

    let LoginStyle = {
      fontSize: '7vw'
    };

    let SignInStyle = {
      fontSize: '3vw'
    };

    let head = <Col>
      <div className="LoginContainer">
        <h1>Forgot Password</h1>
      </div>
    </Col>


    const logo = (divClass, imgClass) => <Col className={divClass}><img className={imgClass}
                                                                        src={"/assets/img/ria-logo.png"}
                                                                        alt=""/></Col>;

    let first = '';
    let second = '';

    if (this.state.mobile) {

      second = <Col><img className="logo pull-right" src={"/assets/img/ria-logo.png"} alt="" width="auto"
                         height="auto"/></Col>;
      first =
        <Col><h1 style={LoginStyle}>Login</h1><p className="text-muted" style={SignInStyle}>Forgot Password</p></Col>;
    }
    else {
      first = head;
      second = logo('', 'logo pull-right');
    }

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-2">
                  <CardBody>

                    <Form noValidate
                          onSubmit={this.handleSubmit}>
                      <Row>
                        {first}
                        {second}
                      </Row>
                      <main>
                        <ToastContainer position="top-right" autoClose={5000} style={{zIndex: 1999}}/>
                      </main>
                      <FormGroup>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user"></i>
                            </InputGroupText>
                          </InputGroupAddon>

                          <Input type="text" placeholder="Username"
                                 autoComplete="username"
                                 id="username"
                                 onChange={this.handleChange}
                                 value={this.state.username}
                                 invalid={this.state.errors["username"] !== undefined}
                          />

                          <FormFeedback>{this.state.errors["username"]}</FormFeedback>

                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup className="mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-phone"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input type="text" placeholder="Cellphone Number"
                                 id="cellphoneNumber"
                                 onChange={this.handleChange}
                                 value={this.state.cellphoneNumber}
                                 invalid={this.state.errors["cellphoneNumber"] !== undefined}
                          />

                          <FormFeedback>{this.state.errors["cellphoneNumber"]}</FormFeedback>

                        </InputGroup>
                      </FormGroup>
                      <Row>
                        <Col>
                          <SFXButtonComponent md={2} className="btn btn-success"
                                              disabled={!this.validateForm()}
                          >Submit</SFXButtonComponent>
                          {'  '}
                          <SFXButtonComponent md={2} className="btn btn-secondary" href={"/login"}
                          >Back</SFXButtonComponent>
                        </Col>
                      </Row>
                    </Form>


                  </CardBody>
                </Card>
              </CardGroup>

              <Modal isOpen={this.state.passwordChangeSuccessfulPopUp} toggle={this.toggle}
                     className={'modal-primary modal-sd ' + this.props.className}>
                <ModalHeader toggle={this.toggle}>Forgot Password</ModalHeader>
                <ModalBody>
                  Your new password has been sent to the number provided. Please login with the new password and change
                  it as soon as possible.
                </ModalBody>
                <ModalFooter>
                  <SFXButtonComponent className={"btn btn-success"}
                                      onClick={this.toggleForgotPassword.bind(this)}
                                      href={"/login"}
                  >Ok</SFXButtonComponent>
                </ModalFooter>
              </Modal>

            </Col>
          </Row>
        </Container>
      </div>


    );
  }
}

export default ForgotPasswordComponent;




// WEBPACK FOOTER //
// ./src/views/Profile/ForgotPasswordComponent.js